module.exports = __webpack_public_path__ + "media/images/print_answer_set/hanamaru-1088fc3007e72908f128008fbdef5e33.png";